import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { EventVenueType } from '@core/enums/event/event-venue-type.enum';
import { OnlineEventType } from '@core/enums/event/online-event-type.enum';
import { EventListItem } from '@core/models/event/event-list-item.model';
import { StoreService } from '@core/services/store/store.service';

@Component({
  selector: 'online-event-watch-stream-icon',
  templateUrl: './online-event-watch-stream-icon.component.html',
  styleUrls: ['./online-event-watch-stream-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnlineEventWatchStreamIconComponent {

  private _event: EventListItem;

  readonly eventType = EventVenueType;
  readonly onlineEventType = OnlineEventType;

  hasTicket: boolean;
  tooltip: string;

  @Input()
  set event(event: EventListItem) {
    this._event = event;
    this.setWatchStream();
  }

  get event(): EventListItem {
    return this._event;
  }

  @Input() readonly tooltipPosition: 'above' | 'right' | 'bottom' | 'left' = 'left';

  @Output() readonly hasNoTicket = new EventEmitter<void>();

  constructor(
    private storeService: StoreService
  ) { }

  private setWatchStream(): void {
    this.hasTicket = false;
    this.tooltip = '';

    if (this.event.type === EventVenueType.ONLINE) {
      const tooltip = this.event.currentStreamType === OnlineEventType.VIDEO ? 'watch_video_stream' : 'watch_live_stream';
      this.tooltip = this.event.isEnabledStreaming ? tooltip : 'online_event';
      this.hasTicket = this.storeService.streamableEvents.includes(this.event.id);
    }
  }

  checkTickets(): void {
    if (this.event.isEnabledStreaming && !this.hasTicket) {
      this.hasNoTicket.emit();
    }
  }

}
